export type FirstRunModelRef = {
  providerID: string
  modelID: string
}

export function resolveFirstRunModel(input: {
  recent: FirstRunModelRef[]
  account?: FirstRunModelRef
  available: FirstRunModelRef[]
}) {
  const available = new Set(input.available.map((model) => `${model.providerID}:${model.modelID}`))
  return [...input.recent, ...(input.account ? [input.account] : [])].find((model) =>
    available.has(`${model.providerID}:${model.modelID}`),
  )
}
